'use client';

import TextHeader from '@/components/Desktop/TextHeader';
import { useContentSize } from '@/components/SizeProvider';

export default function HeaderDesktop() {
  const { width: widthContent, height: heightContent } = useContentSize();
  const lineWidth = `${widthContent * 0.45 - 40}px`;

  return (
    <header className='header-desktop-container'
      style={{
        height: heightContent / 10,
      }}
    >
      <div className={'header-info-container'}
        style={{
          width: widthContent,
        }}
      >
        <div className="line-header"
          style={{
            width: lineWidth,
          }}
        />
        <TextHeader />
        <div className="line-header"
          style={{
            width: lineWidth,
          }}
        />
      </div>
    </header>
  )
}